import i18n from './i18n';
import { DEFAULT_LOCALE, normalizeLocale } from './localeTypes';

type FormatValue = string | number | Date | null | undefined;

function resolveLocale(locale?: string): string {
  return normalizeLocale(locale ?? i18n.resolvedLanguage ?? i18n.language ?? DEFAULT_LOCALE);
}

function normalizeDateValue(value: FormatValue): Date | null {
  if (value == null || value === '') return null;

  const nextValue = value instanceof Date ? value : new Date(value);
  return Number.isNaN(nextValue.getTime()) ? null : nextValue;
}

export function formatDate(
  value: FormatValue,
  locale?: string,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const date = normalizeDateValue(value);
  if (!date) return '';

  return new Intl.DateTimeFormat(resolveLocale(locale), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  }).format(date);
}

export function formatDateTime(
  value: FormatValue,
  locale?: string,
  options: Intl.DateTimeFormatOptions = {},
): string {
  const date = normalizeDateValue(value);
  if (!date) return '';

  return new Intl.DateTimeFormat(resolveLocale(locale), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    ...options,
  }).format(date);
}

export function formatNumber(
  value: number | null | undefined,
  locale?: string,
  options: Intl.NumberFormatOptions = {},
): string {
  if (value == null || Number.isNaN(value)) return '';

  return new Intl.NumberFormat(resolveLocale(locale), options).format(value);
}

export function formatPercent(
  value: number | null | undefined,
  locale?: string,
  options: Intl.NumberFormatOptions = {},
): string {
  if (value == null || Number.isNaN(value)) return '';

  return new Intl.NumberFormat(resolveLocale(locale), {
    style: 'percent',
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
}
